import { createFileRoute } from '@tanstack/react-router'
import { BenefitsConfigPage } from '@/features/admin/benefits/BenefitsConfigPage'

export const Route = createFileRoute('/_authenticated/settings/benefits-config')({
  component: BenefitsConfigPage,
})
